import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { loadStripe, Stripe, StripeElements } from '@stripe/stripe-js';
import { environment } from 'env/environment';
import { getAuth } from 'firebase/auth';
import { switchMap } from 'rxjs/operators';
import { from, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StripeService {
  private stripePromise = loadStripe(environment.stripePublishableKey);

  constructor(private http: HttpClient) { }

  async getStripe(): Promise<Stripe | null> {
    console.log("Stripe key:", environment.stripePublishableKey);
    return this.stripePromise;
  }

  createSubscription(priceId: string): Observable<{ clientSecret: string }> {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error('Not authenticated');
    }

    return from(user.getIdToken()).pipe(
      switchMap(idToken => {
        const url = `https://${environment.apiBaseURL}.cloudfunctions.net/createStripeSubscription`;
        const headers = new HttpHeaders({
          Authorization: `Bearer ${idToken}`,
        });
        return this.http.post<{ clientSecret: string }>(
          url,
          { priceId },
          { headers }
        );
      })
    );
  }

  cancelSubscription(): Observable<{ success: boolean }> {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error('Not authenticated');
    }

    return from(user.getIdToken()).pipe(
      switchMap(idToken => {
        const url = `https://${environment.apiBaseURL}.cloudfunctions.net/cancelStripeSubscription`;
        const headers = new HttpHeaders({
          Authorization: `Bearer ${idToken}`,
        });
        return this.http.post<{ success: boolean }>(
          url,
          {},
          { headers }
        );
      })
    );
  }

  resumeSubscription(): Observable<{ success: boolean }> {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error('Not authenticated');
    }

    return from(user.getIdToken()).pipe(
      switchMap(idToken => {
        const url = `https://${environment.apiBaseURL}.cloudfunctions.net/resumeStripeSubscription`;
        const headers = new HttpHeaders({
          Authorization: `Bearer ${idToken}`,
        });
        return this.http.post<{ success: boolean }>(
          url,
          {},
          { headers }
        );
      })
    );
  }
}
